import { useState, useMemo } from "react";

export function usePagination(data = [], initialRowsPerPage = 5) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const paginatedData = useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    return data.slice(start, end);
  }, [data, page, rowsPerPage]);

  const totalPages = Math.ceil(data.length / rowsPerPage);

  return {
    paginatedData,
    page,
    totalPages,
    rowsPerPage,
    setPage,
    setRowsPerPage,
  };
}

export default usePagination;
